<template>
    <swiper class="swiper carousel-mx-h" :options="swiperOption">
    <swiper-slide class="carousel carousel-mn-w carousel-mn-h"><img src="../../assets/images/product-1.png" alt=""></swiper-slide>
    <swiper-slide class="carousel carousel-mn-w carousel-mn-h"><img src="../../assets/images/product-2.png" alt=""></swiper-slide>
    <swiper-slide class="carousel carousel-mn-w carousel-mn-h"><img src="../../assets/images/product-3.png" alt=""></swiper-slide>
    <swiper-slide class="carousel carousel-mn-w carousel-mn-h"><img src="../../assets/images/product-4.png" alt=""></swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

  import 'swiper/css/swiper.css'

  export default {
    name: 'VerticalCarousel',
    title: 'Vertical slider',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOption: {
          direction: 'vertical',
          slidesPerView: 3,
          spaceBetween: 20,
          mousewheel: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
 @import '../../styles/components/verticalcarousel';
</style>